/**
 * 配置站点地图路由
 * @priority 0.8
 * @changefreq daily
 */

//* Vue Router
import type { RouteRecordRaw } from "vue-router";

export default [
    {
        name: "Gene",
        path: "/gene/:id",
        meta: { type: "Gene", regular_type: "gene", regular: ":id" },
        component: () => import("@/views/details/gene/index.vue"),
    },
    {
        path: "/tool/sequence",
        name: "BioSequence",
        meta: { type: "Sequence" },
        component: () => import("@/views/tool/views/sequence/main/index.vue"),
    },
    {
        path: "/tool/sequence/:id",
        name: "BioSequenceResult",
        meta: { type: "Sequence", regular_type: "gene", regular: ":id" },
        component: () => import("@/views/tool/views/sequence/result/index.vue"),
    },
    {
        path: "/tool/variant",
        name: "BioVariant",
        meta: { type: "Variant" },
        component: () => import("@/views/tool/views/variant/main/index.vue"),
    },
    {
        path: "/tool/variant/:id",
        name: "BioVariantResult",
        meta: { type: "Variant", regular_type: "gene", regular: ":id" },
        component: () => import("@/views/tool/views/variant/result/index.vue"),
    },
    {
        name: "Model",
        path: "/model/:id",
        meta: { type: "Model", regular_type: "model", regular: ":id" },
        component: () => import("@/views/details/model/index.vue"),
    },
    {
        name: "Disease",
        path: "/disease/:id",
        meta: { type: "Disease", regular_type: "disease", regular: ":id" },
        component: () => import("@/views/details/disease/index.vue"),
    },
] as RouteRecordRaw[];
